
import { apiUrl, axiosAuthGet, axiosAuthPost } from './../services/utils';
import { defineComponent } from 'vue';
import { Building } from '../interfaces/building.interface';
import BasicSpinner from '@/components/BasicSpinner.vue';
import { topBarState } from '@/services/topBar';

export default defineComponent({
    setup() {
    },
    mounted() {
        this.getBuildings();
    },
    data() {
        return {
            buildings: [] as Building[],
            spin: false,
            showForm: false,
            topbarState:topBarState,
            formData: {
                name: "",
                description: "",
                location: ""
            }
        };
    },
    methods: {
        getBuildings() {
            this.spin = true;
            let buildingUrl = apiUrl + "buildings/list";
            axiosAuthGet(buildingUrl).then((result) => {
                this.buildings = result;
                console.log(this.buildings);
                this.spin = false;
            }).catch((err) => {
                window.alert("an error occured");
                console.log(err);
                this.spin = false;
            });
        },
        createBuilding() {
            let buildingUrl = apiUrl + "building/create";
            this.spin = true;
            axiosAuthPost(buildingUrl, this.formData).then((result) => {
                this.buildings.push(result.building);
                console.log(this.buildings);
                this.showForm = false;
                this.spin = false;
            }).catch((err) => {
                window.alert("an error occured");
                console.log(err);
                this.spin = false;
            });
        }
    },
    components: { BasicSpinner }
})
